
<!-- Wrapper Body -->
<div class="wrapper-body">
    <div class="page-header d-flex align-items-center">
      <h3>Diagnosticians List</h3>
      <a href="javascript:void" class="theme-button grey ml-auto mr-3" onclick="filterButton()">Filter</a>
      <button class="theme-button" (click)="createDiag()">Create Diagnostician</button>
    </div>
      <!-- Success Message Display -->
      <div *ngIf="successMessage" class="alert alert-success">
        {{ successMessage }}
      </div>
    <div class="content">
      <!-- <form class="custom-form d-none" id="filterShow">
        <div class="row">
          <div class="col-md-6">
            <input type="text" id="filterSearch" placeholder="Type here to search" onkeyup="appointmentFilterFunction()">
          </div>
        </div>
      </form> -->
      <div class="card" >
        <div class="table-responsive">
          <!-- <table class="custom-table filterTable" id="appointmentTable"> -->
            <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" id="appointmentTable" class="custom-table filterTable row-border hover">
            <thead>
              <tr class="header">
                <th>Name</th>
                <th>Username</th>
                <th>Phone</th>
                <th>Email</th>
                <th>Location</th>
                <th>Status</th>
                <th class="text-right">Actions</th>
  
              </tr>
            </thead>
            <tbody>
  
              <!-- Loop -->
              <tr *ngFor="let user of diagnosticiansList">
                <td>{{user.firstName}} {{user.lastName}} </td>
                <td>{{user.username}}</td>
                <td>{{user.mobileNo}}</td>
                <td>{{user.email}}</td>
                <td>{{user.location}}</td>
                <td [ngClass]="{
                  'alert-success' : user.userOption==false,
                  'alert-danger' : user.userOption==true }">
                  <span *ngIf="!user.userOption">Active</span>
                  <span *ngIf="user.userOption">Disabled</span>
                </td>
                <!-- <td class="text-danger">{{user.status}}</td> -->
                <!-- <td><a (click)="getUser(user)" href="" data-toggle="modal" data-target="#viewDiagnosticianModal">View</a></td> -->
                <td><a href="javascript:void(0)" data-toggle="modal" data-target="#editDiaInfo"
                    class="ml-auto px-3 py-2 badge bg-purple text-white float-md-right"
                    (click)="updateClientMethod(user)">Edit</a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
  
  
      <!-- <div *ngIf="diagnosticiansList.length<1">
        <div class="row">
          <div class="col-12">
            <div class="card py-5 px-2 text-center">
              <h4 class="text-grey">No Diagnostician</h4>
              
            </div>
          </div>
        </div>
      </div> -->

    </div>
  </div>
  
  <!-- Edit Client Info Modal -->
  <div class="modal fade" id="editDiaInfo" data-backdrop="static" data-keyboard="false" tabindex="-1"
    aria-labelledby="editDiaInfo" aria-hidden="true">
    <div class="modal-dialog" style="max-width: 700px;">
      <div class="modal-content light py-3 px-4">
        <h5 class="border-bottom mb-3 pb-3 text-center text-green">Edit User</h5>
        <form [formGroup]="updateClient" id="editClientForm" class="custom-form">
          <div class="row light">
            <div class="col-lg-4 col-md-6">
              <label class="small">First Name</label>
              <input type="text" formControlName="firstName" />
            </div>
            <div class="col-lg-4 col-md-6">
              <label class="small">Last Name</label>
              <input type="text" formControlName="lastName">
            </div>
            <div class="col-lg-4 col-md-6">
              <label class="small">Cell Number</label>
              <p-inputMask mask="(999) 999-9999" placeholder="Cell Number" formControlName="mobileNo"></p-inputMask>
            </div>
            <div class="col-lg-4 col-md-6">
              <label class="small">Email</label>
              <input type="text" formControlName="email"
               [ngClass]="{'border border-danger': f['email'].touched && f['email'].errors && f['email'].invalid}">
              <small class="text-danger" *ngIf="updateClient.get('email')?.touched || updateClient.get('email')?.dirty">
                  <span *ngIf="updateClient.get('email')?.errors?.['required']">Email is required.</span>
                  <span *ngIf="updateClient.get('email')?.errors?.['email']">Invalid email format.</span>
                  <span *ngIf="updateClient.get('email')?.errors?.['pattern']">Email must be in a valid format (e.g., user@example.com).</span>
              </small>
              
            </div>
            <div class="col-lg-4 col-md-6" *ngIf='location'>
              <label class="small">Location</label>
              <select id="testingLocation" formControlName="locationId">
                <option value="" selected disabled>Assign Location</option>
                <option *ngFor="let city of location.data" [ngValue]="city.id">{{city.name}}</option>
              </select>
            </div>
            <div class="col-lg-4 col-md-6">
              <label class="small">Username</label>
              <input type="text" formControlName="username">
            </div>
            <div class="col-lg-4 col-md-6">
              <label class="small">Password</label>
              <input type="password" [minlength]="6" formControlName="password">
            </div>
            <div class="col-lg-4 col-md-6">
              <label class="small">Confirm Password</label>
              <input type="password" [minlength]="6" [(ngModel)]="confPass" [ngModelOptions]="{standalone: true}"
                [ngClass]="{'border border-danger': f['password'].value!=confPass }">
            </div>

            <div class="col-lg-4 col-md-6">
              <label class="small">Display Order</label>
              <input type="tel" formControlName="displayOrder" maxlength="3" />
            </div>
            
            <div class="col-lg-4 col-md-6">
              <label *ngIf="!userOption" class="small">Disable User</label>
              <label *ngIf="userOption" class="small">Enable User</label>
              <label class="switch">
                <input type="checkbox" formControlName="userOption">
                <span class="slider round"></span>
              </label>
            </div>
            <!-- <div class="col-lg-4 col-md-6">
                    <label class="small">status</label>
                    <div class="custom-control custom-checkbox">
                      <input type="checkbox"  [checked]="true"
                          class="custom-control-input">
                      
                  </div>
                </div> -->
          </div>
          <div class="row mt-4">
            <div class="col-12 d-flex justify-content-center">
              <!-- <a [ngClass]="{'grey' : updateClient.invalid || f['password'].value!=confPass}"  [disabled]="updateClient.invalid || f['password'].value!=confPass" (click)="onClickSubmit()" class="theme-button mr-3">Update</a> -->
              <button [ngClass]="{'grey' : updateClient.invalid || f['password'].value!=confPass}"
                [disabled]="updateClient.invalid || f['password'].value!=confPass" type="submit" (click)="onClickSubmit()"
                class="theme-button mr-3" form="updateClient" id="createDiagnosticianFormSubmit">Update</button>
  
              <a href="#!" class="theme-button grey" data-dismiss="modal">Don’t Save</a>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  
  <ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-scale-multiple">
    <!-- <p style="color: white">Please Wait... </p> -->
  </ngx-spinner>
